import { render, staticRenderFns } from "./LoginAlerts.vue?vue&type=template&id=67bc3735&scoped=true"
import script from "./LoginAlerts.vue?vue&type=script&lang=js"
export * from "./LoginAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bc3735",
  null
  
)

export default component.exports